import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Select, notification } from 'antd';

import api from '../../services/api';
import { getEmpresa, getTelaAnterior, login, setCnpjEmpresa, setEmpresa, setLocal, setNomeEmpresa, setNomeLocal, setRegimeTributario, setStatusFilial } from '../../services/auth';
import { dadosPdvActions, listaSelectPaginadoActions } from '../../actions';
import { useStateValue } from '../../state';
import { SelectPaginacao } from '../../components';
import maskFormat from '../../ValueObjects/maskFormat';

export default function SelecoesEmpresa({ veioDaHome = false, exibirModal = false }) {
    const [{ dadosPdv }, dispatch] = useStateValue();
    const [codigoEmpresa, setCodigoEmpresa] = useState(null);
    const [codigoLocal, setCodigoLocal] = useState(null);
    const [formLogin] = Form.useForm();

    const acessar = values => {
        buscarTela();
    };

    useEffect(() => {
        if (!!formLogin.getFieldValue()?.emp_id) {
            carregarLocais(formLogin.getFieldValue()?.emp_id);
            setCodigoEmpresa(formLogin.getFieldValue()?.emp_id);
        }

    }, [formLogin.getFieldValue().emp_id]);

    useEffect(() => {
        if (!!codigoLocal) {
            carregarDadosEmpresa();
        }
    }, [codigoLocal]);

    useEffect(() => {
        if (!!veioDaHome) {
            buscarEmpresaUnica();
        }
    }, [exibirModal]);

    function buscarEmpresaUnica() {
        let lista = [];
        let codigo = getEmpresa();
        lista.push({ name: "emp_id", campo: "idEmpresa", value: codigo });
        dispatch({ type: listaSelectPaginadoActions.CHANGE, data: { itens: lista } });
        setCodigoEmpresa(codigo);
    }

    async function carregarDadosEmpresa() {
        let values = {};
        values.emp_id = codigoEmpresa;
        values.loc_id = codigoLocal;
        const listaEmpresa = (await api.get(`Empresa/Buscar/${codigoEmpresa}`)).data;
        await api.post('Local/GerarTokenLogin', values).then(res => {
            if (res.status === 200) {
                login(res.data);
                carregarPdv(codigoLocal);
                setEmpresa(codigoEmpresa);
                setLocal(codigoLocal);
                setNomeEmpresa(listaEmpresa.emp_razaosocial);
                setRegimeTributario(listaEmpresa.emp_regimetributario)
                api.get(`Local/GetLocalById/${codigoLocal}`).then(
                    res => {
                        if (!!res.data) {
                            let listaLocal = res.data;
                            setNomeLocal(listaLocal.loc_descricao);
                            setCnpjEmpresa(listaLocal.loc_cnpj?.numero);
                            setStatusFilial(listaLocal.loc_ativo);
                            buscarTela();
                        }
                    }
                )
                //buscarTela();
            }
        }, err => {
            if (!!err) {
                if (!!err.response && !!err.response.data) {
                    notification.error({ message: err.response.data || 'Falha ao efetuar o login' });
                } else {
                    notification.error({ message: 'Falha ao efetuar o login', description: 'Verifique os dados informados e tente novamente.' });
                }
            } else {
                notification.error({ message: 'Falha ao efetuar o login', description: 'Verifique os dados informados e tente novamente.' });
            }
        });

    }

    function carregarLocais(codEmpresa) {
        let lista = [];
        lista.push({ name: "filial", campo: "codigoEmpresa", value: codEmpresa });
        dispatch({ type: listaSelectPaginadoActions.CHANGE, data: { itens: lista } });
    }

    async function buscarTela() {
        if (!!getTelaAnterior()) {
            if (window.location.hash.replace('#', '') === getTelaAnterior()) {
                window.location.reload();
            } else {
                window.location = `/home#${getTelaAnterior()}`;
                if (window.location.hash !== '' && window.location.hash !== '#/') {
                    window.location.reload();
                }
            }
        } else {
            window.location = "/home";
        }
    }

    async function carregarPdv(valor) {
        let res = null;
        try {
            // Tenta buscar o PDV
            const response = await api.get(`Pdv/BuscarPorLocal/${valor}`);
            res = response.data;

            // Se não encontrou, cria um novo PDV
            if (!res) {
                const pdvDados = {
                    pdv_id: null,
                    pdv_configuracao: 0,
                    pdv_numerocaixa: 1,
                    pdv_registro: 'null.null',
                    pdv_disco: 0,
                    pdv_ram: 0,
                    pdv_resolucaotela: '',
                    pdv_nomecomputador: '',
                    pdv_cpu: '',
                    pdv_ipredelocal: '8.8.8.8',
                    pdv_sistemaoperacional: '',
                    tipoPdv: 1,
                    loc_id: valor
                };
                const criarResponse = await api.post(`Pdv/Incluir`, pdvDados);
                res = criarResponse.data;
            }

            dispatch({ type: dadosPdvActions.CHANGE, data: { pdv: res } });

        } catch (erro) {
            console.error('Erro ao carregar ou incluir PDV:', erro);
        }
    }

    return (
        <div>
            <Form layout="vertical" name="login" size="middle" onFinish={acessar} form={formLogin}>
                <Row align="middle" gutter={[0, 16]}>
                    <Col span={24}>
                        <Form.Item name="empresa" label="Selecione sua Empresa">
                            <SelectPaginacao url="Empresa/ListarEmpresaUsuario" allowClear={true} placeholder="Selecione uma Empresa" nameLabel="emp_nomefantasia" form={formLogin} nameValue="emp_id" name="emp_id" retornaUnico={"emp_id"} onChangeFunction={(value) => setCodigoEmpresa(value)} order="emp_razaosocial"
                                conteudo={
                                    e => (<Select.Option value={e.emp_id} key={e.emp_id} label={e.emp_nomefantasia}>{e.emp_nomefantasia} <br /> Razao Social: {e.emp_razaosocial} </Select.Option>)
                                } />
                        </Form.Item>
                    </Col>
                </Row>
                {formLogin.getFieldValue()?.emp_id && <Row align="middle" gutter={[0, 16]}>
                    <Col span={24}>
                        <Form.Item label="Selecione sua Filial" name="filial">
                            <SelectPaginacao url="Local/ListarLocalUsuario" placeholder="Selecione um local" allowClear={true} retornaUnico={!veioDaHome ? "loc_id" : ""}
                                filtroExtra={`&codigoEmpresa=${formLogin.getFieldValue()?.emp_id}`}
                                form={formLogin} nameLabel="loc_descricao" nameValue="filial"
                                onChangeFunction={(valor) => setCodigoLocal(valor)}
                                conteudo={
                                    l => (
                                        <Select.Option
                                            key={l.loc_id}
                                            value={l.loc_id}
                                            label={`${l.loc_descricao}`} // Para filtragem e visualização no dropdown
                                        >
                                            {l.loc_descricao}  {/* Exibe o loc_id na interface */}
                                            {!l.loc_ativo ? ' (INATIVO)' : ''}
                                            {(!!l.loc_cnpj ? <div>{maskFormat(l.loc_cnpj.numero, '', true)}</div> : '')}
                                        </Select.Option>
                                    )
                                } />
                        </Form.Item>
                    </Col>
                </Row>}
            </Form>
        </div>
    );
}